import { createSelector } from 'reselect';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { enabledSelector } from 'selectors/testTarget/offers/carouselOnPLPCategory/enabled/enabledSelector';

const showCarouselOnPLPCategorySelector = createSelector(isTestTargetReadySelector, enabledSelector, (testReady, enabled) => ({
    enabled: testReady && enabled === true
}));

export { showCarouselOnPLPCategorySelector };
